/**
 * predictive-search-override.js
 * Intercepte les appels fetch vers /search/suggest
 * et les redirige vers /search pour chercher dans les tags.
 *
 * Doit être chargé AVANT les autres scripts — mettre SANS defer dans theme.liquid :
 * {{ 'predictive-search-override.js' | asset_url | script_tag }}
 */
(function () {
  'use strict';

  var originalFetch = window.fetch;

  window.fetch = function (resource, options) {
    var url = typeof resource === 'string' ? resource : (resource instanceof Request ? resource.url : String(resource));

    /* Intercepte uniquement les appels vers /search/suggest */
    if (url && url.includes('/search/suggest')) {
      try {
        var parsed = new URL(url, location.origin);
        var q = parsed.searchParams.get('q');

        if (q) {
          /* Récupère le section_id depuis l'URL ou le composant */
          var sectionId = parsed.searchParams.get('section_id') ||
            parsed.searchParams.get('sections') ||
            (document.querySelector('predictive-search-component') || {}).dataset?.sectionId;

          /* Construit la nouvelle URL vers /search */
          var newUrl = new URL('/search', location.origin);
          newUrl.searchParams.set('q', q);
          newUrl.searchParams.set('type', 'product');
          newUrl.searchParams.set('options[prefix]', 'last');
          if (sectionId) {
            newUrl.searchParams.set('section_id', sectionId);
          }

          console.log('[SearchOverride] intercept:', url, '→', newUrl.toString());

          return originalFetch.call(this, newUrl.toString(), options);
        }
      } catch (e) {
        console.warn('[SearchOverride] parse error:', e);
      }
    }

    return originalFetch.apply(this, arguments);
  };

  console.log('[SearchOverride] fetch interceptor installé');

}());
